import {isFeatureEnabled} from '@github-ui/feature-flags'

export const WEBPUBSUB_BATCHING_FEATURE_FLAG = 'copilot_mission_control_awps_batching'

/**
 * Whether this client may advertise support for Web PubSub batch envelopes.
 * Decoding remains unconditional so a client can safely consume batches once
 * negotiation is enabled.
 */
export function webPubSubBatchingEnabled(): boolean {
  try {
    return isFeatureEnabled(WEBPUBSUB_BATCHING_FEATURE_FLAG)
  } catch {
    return false
  }
}
